import integrationBanner from "../Images/integration_update_banner.svg";
import twitter from "../Images/twitter.svg";
import facebook from "../Images/facebook.svg";
import line from "../Images/line.svg";
import pinterset from "../Images/pinterset.svg";
import slack from "../Images/slack.svg";
import skype from "../Images/skype.svg";
import jira from "../Images/jira.svg";
import instagram from "../Images/instagram.svg";
import { Switch } from '@headlessui/react'
import { useState } from "react";

const integrationData = [
    {
        id: 1,
        title: "Twitter",
        subTitle: "Short brief of intergrations",
        svg: twitter,
        enable: true
    },
    {
        id: 2,
        title: "Facebook",
        subTitle: "Short brief of intergrations",
        svg: facebook,
        enable: false
    },
    {
        id: 3,
        title: "Line",
        subTitle: "Short brief of intergrations",
        svg: line,
        enable: false
    },
    {
        id: 4,
        title: "Pinterest",
        subTitle: "Short brief of intergrations",
        svg: pinterset,
        enable: false
    },
    {
        id: 5,
        title: "Slack",
        subTitle: "Short brief of intergrations",
        svg: slack,
        enable: false
    },
    {
        id: 6,
        title: "Skype",
        subTitle: "Short brief of intergrations",
        svg: skype,
        enable: false
    },
    {
        id: 7,
        title: "Jira",
        subTitle: "Short brief of intergrations",
        svg: jira,
        enable: false
    },
    {
        id: 8,
        title: "Instagram",
        subTitle: "Short brief of intergrations",
        svg: instagram,
        enable: true
    },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Integrations = () => {
    const [data, setData] = useState(integrationData);

    const handleToggle = (id) => {
        setData((prevData) =>
            prevData.map((item) =>
                item.id === id ? { ...item, enable: !item.enable } : item
            )
        );
    }
    return (
        <div style={{padding: "12px 14px" }}>
            <h1 style={{ lineHeight: "10px", color: "#393939", fontFamily: "Source Sans 3", fontSize: "18px", fontWeight: 700, fontStyle: "normal" }}>Connected Apps</h1>
            <p style={{ color: "#868686", margin: "10px 0px 18px 0px", fontFamily: "Source Sans 3", fontSize: "14px", fontWeight: 400, fontStyle: "normal" }}>Dolor sunt non qui adipisicing mollit ad
            </p>
            <div style={{ display: "flex", margin: "12px 0px", gap: "20px", backgroundColor: "#ffe6e8", padding: "7px 14px" }}>
                <img src={integrationBanner} alt="banner" loading="lazy" />
                <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <h2 style={{ lineHeight: "10px", color: "#393939", fontFamily: "Source Sans 3", fontSize: "28px", fontWeight: 700, fontStyle: "normal" }} >We've just released a new update</h2>
                    <p style={{ padding: "16px 0px 20px 0px" }}>Dolor sunt non qui adipisicing mollit ad</p>
                    <div style={{ display: "flex", gap: "10px", flexShrink: 0 }}>
                        <button style={{ border: "1px solid #1C485F", color: "#1C485F", borderRadius: "4px", padding: "7px 12px", outline: "none" }}>Dismiss</button>
                        <button style={{ border: "1px solid #1C485F", color: "#fff", backgroundColor: "#1C485F", borderRadius: "4px", padding: "7px 12px", outline: "none" }}>Update</button>
                    </div>
                </div>
            </div>
            <ul style={{ padding: "5px 0px 0px 0px" }}>
                {
                    data.map((data) => (
                        <li key={data.id} style={{ padding: "10px 0px", borderBottom: integrationData.length !== data.id ? "1.5px solid #F3F4F6" : "1.5px solid transparent" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                                    <img src={data.svg} alt="icon" loading="lazy" />
                                    <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center" }}>
                                        <h2 style={{ lineHeight: "10px", color: "#393939", fontFamily: "Source Sans 3", fontSize: "15px", fontWeight: 700, fontStyle: "normal" }} >{data.title}</h2>
                                        <p style={{ lineHeight: "10px", color: "#393939", fontFamily: "Source Sans 3", fontSize: "12px", fontStyle: "normal" }}>{data.subTitle}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                                    <span style={{ color: "#393939", fontFamily: "Source Sans 3" }}>Learn more</span>
                                    <Switch
                                        checked={data.enable}
                                        onChange={() => handleToggle(data.id)}
                                        className={classNames(
                                            data.enable ? 'bg-indigo-600' : 'bg-gray-200',
                                            'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2'
                                        )}
                                        style={{ height: "24px", width: "44px", borderRadius: "50px", backgroundColor: data.enable ? "#E5E5E5" : "#F2F2F2" }}
                                    >
                                        <span className="sr-only">Use setting</span>
                                        <span
                                            aria-hidden="true"
                                            className={classNames(
                                                data.enable ? 'translate-x-5' : 'translate-x-0',
                                                'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                            )}
                                            style={{ transition: 'width 200ms ease-in-out', height: "20px", width: "20px", borderRadius: "100%", backgroundColor: data.enable ? "#1C485F" : "white", transform: data.enable ? 'translateX(20px)' : 'translateX(0)' }}
                                        />
                                    </Switch>
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default Integrations